<template>
  <div>
    <h1 class="mp-color-default">{{ endpoint.name }}</h1>
    <h3 class="mp-color-console">Implementation Notes</h3>
    <p class="uk-flex uk-flex-middle">{{ endpoint.description }} <a class="uk-text-bold uk-button uk-button-small" :href="endpoint.link" target="_blank">Read More</a></p>
    <div v-if="endpoint.disabled" class="uk-alert uk-alert-danger">{{ endpoint.disabled_message }}</div>
  </div>
</template>

<script>
  export default {
    name: "EndpointOverview",
    props: ["endpoint"]
  }
</script>
